import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchData, resetFilter, resetList } from '../../actions'

import SearchBar from './SearchBar'
import List from './List'

class Section extends Component {
  componentDidMount () {
    // console.log('mounted')
    this.props.resetList()
    this._fetchData()
    this.props.resetFilter()
  }

  componentWillUnmount () {
    // console.log('unmounting')
    this.props.resetList()
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { title, category, mainID, labels, labelsID, list: { data, loading, errorMsg } } = this.props
    if (
      title !== nextProps.title ||
      category !== nextProps.category ||
      mainID !== nextProps.mainID ||
      labels !== nextProps.labels ||
      labelsID !== nextProps.labelsID ||
      data !== nextProps.list.data ||
      loading !== nextProps.list.loading ||
      errorMsg !== nextProps.list.errorMsg
    ) {
      return true
    } else {
      return false
    }
  }

  _fetchData (init) {
    const { category, fetchData } = this.props
    fetchData(category, init)
  }

  // _handleFilterSubmit (fieldFilter, valueFilter) {
  //   console.log('field filter: ', fieldFilter)
  //   console.log('value filter: ', valueFilter)
  //   this.setState({ fieldFilter, valueFilter })
  // }

  _renderResultNumber () {
    if (this.props.list.data) {
      return (
        <div className="total_result regular flex justify-between align-center bold">
          {
            !this.props.loading
              ? this.props.list.data.length
              : null
          }件
        </div>
      )
    }
  }

  _renderAddBtn () {
    if (this.props.category === 'owners') {
      return (
        <div className="flex add_owner_btns">
          <Link key="add_agency" to={`/owners/add/agency`} className="btn primary small_btn flex align-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span>管理会社追加</span>
          </Link>
          <Link key="add_owner" to={`/owners/add/owner`} className="btn primary small_btn flex align-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span>オーナー追加</span>
          </Link>
        </div>
      )
    }
    return null
  }

  render () {
    // console.log('rendering section: ', this.props)
    const { title, category, mainID, labels, list: { loading, data } } = this.props
    return (
      <section>
        <h4 className="page_title bold">{ title }</h4>

        <SearchBar labels={labels}/>

        <div className="row flex justify-between align-end">
          { this._renderResultNumber() }
          { this._renderAddBtn() }
        </div>

        <List
          mainID={ mainID }
          category={ category }
          labels={ labels }
          data={ data }
          loading={ loading }
          // fieldFilter={ this.state.fieldFilter }
          // valueFilter={ this.state.valueFilter }
        />
      </section>
    )
  }
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.oneOf([ 'owners', 'properties', 'residents' ]).isRequired,
  mainID: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.object).isRequired
}

Section.defaultProps = {

}

function mapStateToProps ({ list }) {
  return { list }
}

export default connect(mapStateToProps, { fetchData, resetFilter, resetList })(Section)



// WEBPACK FOOTER //
// ./src/components/_common/Section.js